import React, {Component} from 'react';
import {NavBar, Checkbox} from 'antd-mobile';
import {connect} from "react-redux";
import "./style.less";
const CheckboxItem = Checkbox.CheckboxItem;
@connect(
    state => ({userInfo: state.userInfo}),
)

export default class PayDetail extends Component {
    constructor(props) {
        super(props);
        console.log(props);
        this.state = {
          pay:true,
        };

    }

    componentDidMount() {
    }
    onChange=(e,key)=>{
      this.setState({
          [key]:e.target.checked
      })
    };
    pay = () => {
      document.location = `js://webview?orderNo=${this.props.history.location.state.orderNum}&token=${this.props.userInfo.token}&type=${this.props.history.location.state.type}`;
    };
    render() {
        return (
            <div className="payDetail">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()}/>}
                >支付</NavBar>
               <div className="content">
                  <div className="seatInfo">
                    <div>
                      <span>出行位置</span>
                      <span>{this.props.history.location.state.seatNum}号</span>
                    </div>
                    <div>
                      <span>支付金额</span>
                      <span>￥{this.props.history.location.state.totalPrice}</span>
                    </div>
                  </div>
                  <div className="select"><span>选择支付方式</span></div>
                  <div className="pay">
                    <i className="icon iconfont iconweixinzhifu"></i>
                    <div>
                      <span>微信支付</span>
                      <p>亿万用户的选择，更快更安全</p>
                    </div>
                    <CheckboxItem checked={true}/* onChange={(e) => this.onChange(e,'pay')} checked={this.state.pay} */></CheckboxItem>
                  </div>
                  <div className="addBtn" onClick={this.pay}>立即支付</div>
               </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Shift/PayDetail/index.js